module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1126.b1d5dcb1.png";